module.exports = __webpack_public_path__ + "media/kommissar_1.1a.523ff717.mp3";